import * as Immutable from 'immutable';
import type { SessionMismatchReason } from '../_actions/AuthActions';

export interface IAuthStore {
	modalOpened: boolean,
	isSignup: boolean,
	signup_email: string,
  signup_service: string,
	sessionMismatchDialogOpened: boolean,
	sessionMismatchReason: SessionMismatchReason | null,
}

const defaultStore = Immutable.Record<IAuthStore>({
	modalOpened: false,
	isSignup: false,
	signup_email: '',
  signup_service: '',
	sessionMismatchDialogOpened: false,
	sessionMismatchReason: null,
});

export default class AuthStore extends defaultStore implements IAuthStore {}
